
import React, { useState } from 'react';
import SearchForm from '../components/SearchForm';
import SearchResults from '../components/SearchResults';

const Index = () => {
  
  // const [isVerified, setIsVerified] = useState(false);
  const [searchData, setSearchData] = useState(null);
  const handleSearch = (data) => {
    setSearchData(data);
  };

  return (
    <div className="index-page">
        <SearchForm onSearch={handleSearch} />
        {searchData && <SearchResults data={searchData} />}
    </div>
  );
};

export default Index;
